import { DynamicProfileHubBase } from '../DynamicProfileHubBase';
import { ProfileStoreType } from '../DynamicProfileEnums';
import { DynamicUGOProfileStore } from './DynamicUGOProfileStore';
import { DynamicUGOMapStore } from './DynamicUGOMapStore';
import { DynamicUGOTableStore } from './DynamicUGOTableStore';

class DynamicUGOHub extends DynamicProfileHubBase {
  protected _profileStore: DynamicUGOProfileStore | undefined;
  protected _mapStore: DynamicUGOMapStore | undefined;
  protected _tableStore: DynamicUGOTableStore | undefined;

  public createStore(storeType: ProfileStoreType, option: any = void 0) {
    switch (storeType) {
      case ProfileStoreType.MAP:
        this._mapStore = new DynamicUGOMapStore(this);
        this.MapStore!.MapView = option?.mapView;
        this.disposer.Track(this._mapStore);
        break;

      case ProfileStoreType.PROFILE:
        this._profileStore = new DynamicUGOProfileStore(this);
        this.disposer.Track(this._profileStore);
        break;

      case ProfileStoreType.TABLE:
        this._tableStore = new DynamicUGOTableStore(this);
        this.disposer.Track(this._tableStore);
        break;

      default:
        break;
    }
  }

  private _setStore;
  set setStore(setStore) {
    this._setStore = setStore;
  }
  get setStore() {
    return this._setStore;
  }

  private _ugoDesignStore;
  public get ugoDesignStore() {
    return this._ugoDesignStore;
  }
  public set ugoDesignStore(value) {
    this._ugoDesignStore = value;
  }
}

export { DynamicUGOHub };
